<template>
  <div id="app">
    <div v-if="loading" class="page-loader">
      <!-- <breeding-rhombus-spinner
        :animation-duration="2000"
        :size="65"
        color="#20409a"
      /> -->
      <!-- <trinity-rings-spinner
          :animation-duration="1500"
          :size="66"
          color="#20409a"
        /> -->
        <hollow-dots-spinner
            :animation-duration="1000"
            :dot-size="15"
            :dots-num="3"
            color="#20409a"
          />
          <!-- <swapping-squares-spinner
            :animation-duration="1000"
            :size="65"
            color="#20409a"
          /> -->
    </div>
    <div v-else>
      <vue-progress-bar></vue-progress-bar>
      <router-view/>
    </div>
  </div>
</template>

<script>
import { 
  // BreedingRhombusSpinner,
      HollowDotsSpinner, 
      // SwappingSquaresSpinner,
      // TrinityRingsSpinner, 
      } from 'epic-spinners'
export default {
  name: "App",
  components: {
    //  BreedingRhombusSpinner, 
    HollowDotsSpinner, 
    // SwappingSquaresSpinner,
    // TrinityRingsSpinner, 
  },
  data(){
    return {
      loading: true
    }
  },
  created () {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$Progress.finish()
    })
  },
  mounted(){
    setTimeout(() => {
      this.loading = false;
      this.$Progress.finish();
    }, 3000)
  }
}
</script>

<style>
.page-loader{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
@font-face {
    font-family: "BwAletaNo10";
    src: url('~@/assets/KOVATEK/FONTS/BwAletaNo20-Regular.otf') format('opentype'),
     url('~@/assets/KOVATEK/FONTS/BwAletaNo10-Black.otf') format('opentype'),
     url('~@/assets/KOVATEK/FONTS/BwAletaNo10-BlackItalic.otf') format('opentype'),
     url('~@/assets/KOVATEK/FONTS/BwAletaNo10-Bold.otf') format('opentype'),
     url('~@/assets/KOVATEK/FONTS/BwAletaNo10-BoldItalic.otf') format('opentype'),
     url('~@/assets/KOVATEK/FONTS/BwAletaNo10-RegularItalic.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  #app{
      font-family: 'BwAletaNo10', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
    }
  .kovatek-width{
    max-width: 1350px;
    margin: auto; 
  }
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
.add-rounded{
  border-radius: 15px;
}
.add-rounded-1{
  border-radius: 5px;
}
.add-rounded-2{
  border-radius: 10px;
}
.kova-bg{
  background-color: #20409A;
}
.kova-bg-gradient{
  background: linear-gradient(to right, #4BB38E, #20409A);
}
.orange-bg-gradient{
  background:linear-gradient(to right, rgb(255, 216, 110), rgb(241,100,45));
}
.intermediate{
  color: #ACAC21;
}
.kova-text{
  color: #20409a;
}
.kova-light{
  color: #ababab
}
.kova-green{
  color: #4BB38E
}
.kova-bg-green{
  background-color: #4BB38E
}
.btn-kovatek{
  background-color: #20409A;
  color: #fff;
  transition: .25s;
  border: solid 1px #20409a;
  border-radius: 5px;
  outline: 0;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.btn-outline-kovatek{
  background-color: #fff;
  border: solid 1px #20409a;
  outline: 0;
  color: #20409a;
  border-radius: 5px;
  transition: .25s;
}
.btn-outline-kovatek:hover{
  background-color: #f1f1f1;
  border: solid 1px #20409a;
  color: #20409a;
}
.btn-transparent-kovatek{
  border: solid 1px #fff; 
  background: transparent;
  outline: 0;
  color: #fff;
  border-radius: 5px;
  transition: .25s;
}
.btn-transparent-kovatek:hover{
  background-color: #ffffff;
  color: #20409a;
}
.btn-rounded{
  border-radius: 30px;
}
.very-bold{
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
}
/* styling checkbox */

.checkbox-label {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 14px;
    line-height: 24px;
    height: 20px;
    width: 100%;   
}
.checkbox-label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkbox-label .checkbox-custom {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 21px;
    width: 21px;
    background-color: transparent;
    border-radius: 5px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    /* border: 2px solid #20409a; */
    background: linear-gradient(to bottom, #4BB38E, #20409A);

}
.checkbox-label input:checked ~ .checkbox-custom {
    background: linear-gradient(to bottom, #4BB38E, #20409A);
    border-radius: 5px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity:1;
    /* border: 2px solid #20409a; */
    border: solid 0;
}
.checkbox-label .checkbox-custom::after {
    position: absolute;
    content: "";
    left: 12px;
    top: 12px;
    height: 0px;
    width: 0px;
    border-radius: 5px;
    border: solid #20409a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity:1;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
}
.checkbox-label input:checked ~ .checkbox-custom::after {
  -webkit-transform: rotate(45deg) scale(1);
  -ms-transform: rotate(45deg) scale(1);
  transform: rotate(45deg) scale(1);
  opacity:1;
  left: 8px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  background-color: transparent;
  border-radius: 0;
}
/* For Ripple Effect */
.checkbox-label .checkbox-custom::before {
    position: absolute;
    content: "";
    left: 10px;
    top: 10px;
    width: 0px;
    height: 0px;
    border-radius: 5px;
    border: 2px solid #20409a;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);    
}
.checkbox-label input:checked ~ .checkbox-custom::before {
    left: -3px;
    top: -3px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    -webkit-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3);
    opacity:0;
    z-index: 999;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
}

/* styling radio */

.radio{
        position: relative;
        cursor: pointer;
        line-height: 20px;
        font-size: 14px;
        margin: 15px;
     }
  
  .label{
        position: relative;
        display: block;
        float: left;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        border: 1px solid #20409A;
        border-radius: 100%;
        -webkit-tap-highlight-color: transparent;
  }
    
    .label::after{
        content: '';
        position: absolute;
        top: 4px;
        left: 4px;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background: #20409A;
        transform: scale(0);
        transition: all .5s ease;
        opacity: .08;
        pointer-events: none;
    }
      
  .label:hover + .label::after{
      transform: scale(3.6)
  }
    
  
input[type="radio"]:checked + .label{
        border-color:#20409A;
    }

  input[type="radio"]:checked + .label::after{
        transform: scale(1);
        transition: all .5s cubic-bezier(.35,.9,.4,.9);
        opacity: 1;
  }
.hidden{
  display: none;
}

</style>
